import React, { useEffect, useState } from 'react'

const ReloadUsersCourses = (props) => {

  const [isLoading, setIsLoading] = useState(false)

  async function ReloadUsersAccess() {
    const URLParams = new URLSearchParams(location.search)
    const planID = URLParams.get('post')

    const url = restUrl + '/wp-json/membersync/v1/plan/members/courses'
    const nonce = restNonce

    await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            'plan': planID
        }),
        headers:{
            'X-WP-Nonce': nonce,
            'Content-type': 'application/json'
        }
    }).then(resp => {
        return resp.json()
    }).then(json => {
        setIsLoading(false)
    })
  }

  useEffect(() => {

    if( isLoading ) {
        ReloadUsersAccess()
    }

  }, [isLoading])

  return (
    <>
        <input type="button" value={isLoading ? "Loading..." : "Reload members access to courses" } class="msync-button-reload-members-courses-access" disabled={isLoading} onClick={() => {
            setIsLoading(true)
        }} />
    </>
  )
}

export default ReloadUsersCourses
